import n from "./ScalarPageLink.vue.js";
import { createEditorVueNode as r } from "../../../helpers/nodeFactory.js";
import { renderVueElement as a } from "../../../helpers/staticRendering.js";
import { toggleCommandFactory as i } from "../../../helpers/toggleCommands.js";
import s from "./CustomPageLink.vue.js";
import g from "./customPageLinkIcon.svg.js";
const t = "custom_page_link", o = "togglePageLink", k = {
  id: 7,
  name: "Page Link",
  command: ({ editor: e, range: m }) => i(e, m, { name: o, params: {} }),
  hotkey: "⌘ ⇧ 4",
  markdown: "",
  svg: g
}, C = {
  name: t,
  render: (e) => a(n, { ...e })
}, _ = r(
  {
    name: t,
    vueComponent: s,
    draggable: !0,
    addAttributes() {
      return {
        item: void 0
      };
    },
    addCommands() {
      return {
        [o]: () => ({ commands: e }) => e.insertContent({ type: this.name })
      };
    }
  },
  { atom: !0, selectable: !0, group: "block" }
);
export {
  C as customPageLinkStatic,
  _ as default,
  k as pageLinkSuggestion
};
